import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { useState } from 'react'
import { useEffect } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../Settings'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  dialogContent: {
    maxWidth: 300,
  }
})

const UpdateDialog = (props) => {
  const [open, setOpen] = useState(false)
  const settingsContext = useContext(SettingsContext)

  useEffect(() => {
    if (settingsContext.version && process.env.REACT_APP_VERSION) {
      let requiredClientVersion = settingsContext.version.requiredVersion.browser.split('.')
      let clientVersion = process.env.REACT_APP_VERSION.split('.')

      if (
        requiredClientVersion.length !== 3 ||
        clientVersion.length !== 3
      ) {
        return
      }

      for (let index = 0; index < 3; index++) {
        if (parseInt(requiredClientVersion[index], 10) > parseInt(clientVersion[index], 10)) {
          setOpen(true)
          break
        }
        else if (parseInt(requiredClientVersion[index], 10) < parseInt(clientVersion[index], 10)) {
          break
        }
      }
    }
  }, [settingsContext.version])

  const handleClickClose = () => {
    setOpen(false)
  }

  const handleClickReload = () => {
    window.location.reload(true)
  }

  return (
    <Dialog open={open} onClose={handleClickClose}>
      <DialogTitle>注意</DialogTitle>
      <DialogContent className={props.classes.dialogContent}>
        <Typography>アプリケーションのバージョンが古いため正常に動作しない可能性があります。下記のボタンからページをリロードして、アプリケーションを最新にしてください。</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClickClose}>Close</Button>
        <Button variant={'contained'} color={'primary'} onClick={handleClickReload}>Reload</Button>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles, { withTheme: true })(UpdateDialog)



// WEBPACK FOOTER //
// ./src/Parts/UpdateDialog/UpdateDialog.js